import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Music2, Youtube } from "lucide-react";
import { api } from "../../lib/api";

export function ShopFooter() {
  const [site, setSite] = useState({});
  useEffect(() => { api.get("/settings/site").then(({ data }) => setSite(data)).catch(() => {}); }, []);

  return (
    <footer className="mt-20 bg-brand-ink text-white/80">
      <div className="w-full max-w-md mx-auto sm:max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col sm:flex-row justify-between gap-8">
          <div className="max-w-sm">
            <div className="flex items-center gap-2 mb-3">
              <span className="w-9 h-9 rounded-lg bg-white/10 flex items-center justify-center">
                <img src="/noumabou-emblem.png" alt="" className="w-6 h-6 object-contain" />
              </span>
              <span className="font-heading font-extrabold text-xl text-white">NOUMABOU</span>
            </div>
            <p className="text-sm leading-relaxed text-white/60">
              Nourrir l'âme, soigner le corps. Ministère et compléments alimentaires naturels.
              Paiement Tmoney, Flooz ou en ligne — partout au Togo.
            </p>
            <div className="flex gap-3 mt-4">
              {site.tiktok_boutique_url && (
                <a href={site.tiktok_boutique_url} target="_blank" rel="noreferrer" data-testid="footer-tiktok-boutique" className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white"><Music2 className="w-4 h-4" /> TikTok Boutique</a>
              )}
              {site.tiktok_ministry_url && (
                <a href={site.tiktok_ministry_url} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white"><Music2 className="w-4 h-4" /> TikTok Ministère</a>
              )}
              {site.youtube_channel_url && (
                <a href={site.youtube_channel_url} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm text-white/70 hover:text-white"><Youtube className="w-4 h-4" /> YouTube</a>
              )}
            </div>
            <p className="text-sm text-white/50 mt-4">Appels : +228 90 43 12 94<br />WhatsApp : +228 78 89 19 45 · Lomé, Togo</p>
          </div>
          <div className="text-sm">
            <p className="font-heading font-semibold text-white mb-3">Explorer</p>
            <div className="flex flex-col gap-2 text-white/60">
              <Link to="/" className="hover:text-white">Accueil</Link>
              <Link to="/ministere" className="hover:text-white">Ministère</Link>
              <Link to="/boutique" className="hover:text-white">Boutique</Link>
            </div>
            <p className="font-heading font-semibold text-white mb-2 mt-5">Paiements</p>
            <div className="flex gap-2">
              <span className="px-3 py-1 rounded-full bg-tmoney text-black font-semibold text-xs">Tmoney</span>
              <span className="px-3 py-1 rounded-full bg-flooz text-white font-semibold text-xs">Flooz</span>
              <span className="px-3 py-1 rounded-full bg-white/10 text-white font-semibold text-xs">Cash</span>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-white/10 text-xs text-white/50 flex flex-col sm:flex-row flex-wrap items-center justify-center gap-x-3 gap-y-1 text-center">
          <span>© {new Date().getFullYear()} <span className="font-semibold text-white/70">NOUMABOU Ministries™</span> — Boutique Togo 🇹🇬</span>
          <span className="hidden sm:inline text-white/25">|</span>
          <a href="https://www.noumabou.org" target="_blank" rel="noreferrer" className="hover:text-white">www.noumabou.org</a>
          <span className="hidden sm:inline text-white/25">|</span>
          <a href="mailto:info@noumabou.org" className="hover:text-white">info@noumabou.org</a>
        </div>
      </div>
    </footer>
  );
}
